import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight, CheckCircle2 } from "lucide-react";
import { RESOURCE_BY_SLUG } from "../lib/resources";

export default function ResourceDetailPage() {
  const { slug } = useParams();
  const resource = RESOURCE_BY_SLUG[slug];

  if (!resource) return <Navigate to="/care-portal/resources" replace />;

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-testid={`resource-detail-${resource.slug}`}>
      <Link to="/care-portal/resources" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#4A6FA5] mb-8" data-testid="resource-back-link">
        <ArrowLeft className="w-4 h-4" /> All resources
      </Link>

      <p className="text-xs uppercase tracking-[0.2em] text-[#4A6FA5] font-medium mb-3">Guide</p>
      <h1 className="font-heading text-4xl sm:text-5xl tracking-tight text-slate-900 leading-[1.05]">
        {resource.title}
      </h1>
      <p className="mt-5 text-lg text-slate-600 leading-relaxed">{resource.summary}</p>

      <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 md:p-8 shadow-sm">
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-medium mb-4">In this guide</p>
        <ul className="space-y-3">
          {resource.points.map((p) => (
            <li key={p} className="flex items-start gap-3 text-slate-700">
              <CheckCircle2 className="w-5 h-5 text-[#4A6FA5] shrink-0 mt-0.5" strokeWidth={1.75} />
              <span className="leading-relaxed">{p}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-10 prose prose-slate max-w-none">
        <p className="text-base text-slate-700 leading-relaxed whitespace-pre-line">{resource.body}</p>
      </div>

      <div className="mt-12 rounded-2xl bg-[#F0F4F8] border border-blue-100 p-6 md:p-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h3 className="font-heading text-xl font-medium text-slate-900">Talk to a chaplain</h3>
          <p className="text-sm text-slate-600 mt-1">Confidential within applicable ethical and legal limits. Employers receive only aggregate, non-identifying utilization reports — not employee names or written accounts of confidential conversations.</p>
        </div>
        <Link
          to="/care-portal/request-support"
          data-testid="resource-cta-request"
          className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-[#4A6FA5] text-white font-medium hover:bg-[#3B597B] transition-colors"
        >
          Request support <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
}
